import type {
  CoreBookingDocument,
  CoreBookingDocumentPayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Create a booking document.
 *
 * @endpoint POST /api/saas/me/bookings/{bookingId}/documents
 * @scope saas
 * @see https://flecto.dev/api-5091111
 */
export async function createBookingDocument(
  bookingId: ParameterID,
  document: CoreBookingDocumentPayload,
  options?: { signal?: AbortSignal }
): Promise<CoreBookingDocument> {
  const { signal } = options || {}
  const response = await api.post(
    `/api/saas/me/bookings/${bookingId}/documents`,
    document,
    { signal }
  )

  return response?.data?.booking_document
}
